/* unplugin-vue-components disabled */import script from "./proList.vue?vue&type=script&setup=true&lang=js"
export * from "./proList.vue?vue&type=script&setup=true&lang=js"

import "./proList.vue?vue&type=style&index=0&id=f6b8c9f6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6b8c9f6"]])

export default __exports__